import { ReactNode, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "@jambushrushti/contexts/AdminAuthContext";
import { supabase } from "@jambushrushti/integrations/supabase/client";

interface ProtectedScholarRouteProps {
  children: ReactNode;
}

export function ProtectedScholarRoute({
  children,
}: ProtectedScholarRouteProps) {
  const { isAuthenticated, isLoading, user } = useAdminAuth();
  const [isAssigningRole, setIsAssigningRole] = useState(false);

  // Auto-assign scholar role if user is authenticated but doesn't have scholar/admin role
  useEffect(() => {
    const assignScholarRole = async () => {
      if (isAuthenticated && user && user.role === "user") {
        setIsAssigningRole(true);
        try {
          // Update the user's role to scholar
          await supabase
            .from("user_roles")
            .update({ role: "scholar" })
            .eq("user_id", user.id);

          // Refresh the page to get updated role
          window.location.reload();
        } catch (error) {
          console.error("Failed to assign scholar role:", error);
        }
        setIsAssigningRole(false);
      }
    };

    assignScholarRole();
  }, [isAuthenticated, user]);

  if (isLoading || isAssigningRole) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center">
          <div className="border-orange mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-t-transparent" />
          <p className="text-muted-foreground">Loading Scholar Portal...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/scholar/login" replace />;
  }

  // Allow all authenticated users - they get auto-upgraded to scholar role
  return <>{children}</>;
}
